import { render, staticRenderFns } from "./CancelPayment.vue?vue&type=template&id=60a4dcbe"
import script from "./CancelPayment.vue?vue&type=script&lang=js"
export * from "./CancelPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports